'use client';

import ContactSection from '@/components/contacts/ContactSection';
import { useEntraAuth } from '@/components/hooks/useEntraAuth';
import contactsData from '@/content/contacts/en/contacts-data.json';
import { Stack } from '@mui/material';
import { spacing } from '@/theme/tokens';
import BrokersSection from '@/components/contacts/BrokersSection';
import NoticeAndDisclaimerSection from '@/components/contacts/NoticeAndDisclaimerSection';

export default function ContactsPageClient() {
    const { isAuthenticated } = useEntraAuth();

    return (
        <Stack direction="column" gap={spacing[16]}>
            <ContactSection
                title={contactsData.officeContacts.title}
                locations={contactsData.officeContacts.locations}
                isAuthenticated={isAuthenticated}
            />
            <BrokersSection brokers={contactsData.brokerContacts.locations} />
            <NoticeAndDisclaimerSection />
        </Stack>
    );
}
